<template>
  <AppSkeletonCardTable v-if="loading" />
  <Card v-else>
    <template v-slot:title>Serviços</template>
    <template v-slot:content>
      <DataTable
        :value="results"
        responsiveLayout="stack"
        :scrollable="$isLargeScreen.value"
      >
        <Column header="ID" field="id" :sortable="true" style="min-width: 75px">
          <template #body="{ data }">
            <router-link
              :to="{
                name: 'service.edit',
                params: { id: data.id },
              }"
              target="_blank"
              style="text-decoration: none"
            >
              {{ data.id }}
            </router-link>
          </template>
        </Column>
        <Column
          header="Tipo"
          field="type.name"
          headerStyle="min-width: 160px"
          style="min-width: 160px"
          :sortable="true"
        >
          <template #body="{ data }">
            <ServiceType
              :value="data?.type?.path"
              :background="data?.type?.color"
            ></ServiceType>
          </template>
        </Column>
        <Column
          header="Dt. Execução do Serviço"
          field="dateExecuted"
          :sortable="true"
          style="min-width: 145px"
        >
          <template #body="props">
            {{
              props.data.dateExecuted
                ? $dayjs(props.data.dateExecuted).format('DD/MM/YYYY')
                : '-'
            }}
          </template>
        </Column>
        <Column
          header="Situação"
          field="isDone"
          :sortable="true"
          style="min-width: 100px"
        >
          <template #body="{ data }">
            <span v-if="data.isDone" class="service-done"> Concluído </span>
            <span v-else> Pendente </span>
          </template>
        </Column>
        <Column header="Valor" field="description" :sortable="true">
          <template #body="{ data }">
            {{ data.bovineValue ? $toCurrency(data.bovineValue) : '-' }}
          </template>
        </Column>
        <Column
          header="Inseminação"
          field="bullTypeName"
          :sortable="true"
          style="min-width: 140px"
        >
          <template #body="props">
            {{ props.data.bullTypeName || '-' }}
          </template>
        </Column>
        <Column header="Descrição" field="description" :sortable="true">
          <template #body="{ data }">
            {{ data.description || '-' }}
          </template>
        </Column>
      </DataTable>
      <Paginator
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        @page="onPageChange"
      ></Paginator>
    </template>
  </Card>
</template>

<script>
import { ServiceApi } from '../../../services/api';
import ServiceType from '../../Service/components/ServiceType';

export default {
  name: 'BovineServicesCard',
  props: {
    id: Number,
  },
  components: {
    ServiceType,
  },
  data() {
    return {
      query: {
        pageSize: 10,
        bovineId: this.id,
      },
      loading: false,
      results: [],
      pagination: {
        total: 0,
        current: 1,
        pages: 1,
      },
    };
  },
  async created() {
    await this.fetchServices();
  },
  methods: {
    async fetchServices(query = {}) {
      try {
        this.loading = true;
        const { results, pagination } = await ServiceApi.fetch({
          ...this.query,
          ...query,
        });
        this.pagination = pagination;
        this.results = results.map((result) => {
          const serviceBovine = result?.bovines.find(
            (b) => b.bovineId === this.id
          );
          return {
            ...result,
            isDone: !!result?.bovines?.[0]?.done,
            bullTypeName: serviceBovine?.bullType?.name,
            dateExecuted: serviceBovine.dateExecuted,
          };
        });
        this.$emit('load', this.results);
      } finally {
        this.loading = false;
      }
    },
    async onPageChange({ page }) {
      await this.fetchServices({ page: page + 1 });
    },
  },
};
</script>

<style lang="scss" scoped>
.service-done {
  color: #689f38;
}
</style>